module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0152.jpg?v=e6de1e3e";